import FormField from 'components/@common/FormField'
import Email from 'components/Email'
import MobileTelephone from 'components/MobileTelephone/MobileTelephone'
import { checkMarketingOptInStateAndForward } from 'containers/MarketingPreferencesContainer/actions'
import {
  doesAccountExist,
  updateRiskData,
} from 'containers/RiskDataCollectionPage/actions'
import { useAffiliate, useRiskData, useScheme, useVehicle } from 'hooks'
import { useFormikContext } from 'formik'
import React from 'react'
import { useDispatch } from 'react-redux'
import { BaseDriverFormData } from '../../DriverDetails.types'

import './style.css'
import { trackAmplitudeEvent } from 'utils/analytics-helpers'

interface Props {
  shouldHandleBlur?: boolean
}
const MarketingPreferencesForm: React.FC<Props> = ({
  shouldHandleBlur = false,
}) => {
  const dispatch = useDispatch()
  const { values } = useFormikContext<BaseDriverFormData>()
  const { riskData } = useRiskData()
  const { scheme } = useScheme()
  const { vehicleType } = useVehicle()
  // WE only want to do this on a variant
  // TODO: EVALUATE THIS BEING DONE ALWAYS AFTER EXPERIMENT
  const handleBlur = () => {
    trackAmplitudeEvent('email_mobile_entered', {
      quote_id: riskData.QuoteId,
      product_type: vehicleType,
      scheme: scheme,
    })
    if (values.emailAddress && values.mobile && shouldHandleBlur) {
      dispatch(
        updateRiskData({
          EmailAddress: values.emailAddress,
          Mobile: values.mobile,
        }),
      )
      dispatch(checkMarketingOptInStateAndForward())
    }
    if (values.mobile) {
      dispatch(
        updateRiskData({
          Mobile: values.mobile,
        }),
      )
      dispatch(doesAccountExist())
    }
  }

  return (
    <>
      <FormField name='mobile' label='Enter phone number'>
        <MobileTelephone onBlur={handleBlur} />
      </FormField>
      <FormField name='emailAddress' label='Enter your email'>
        <Email onBlur={handleBlur} />
      </FormField>
    </>
  )
}
export default MarketingPreferencesForm
